import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface MenuItem {
  id?: string;
  menu?: string;
  roleId?: number;
  parentId?: string;
  icon?: string;
  path?: string;
  active?: boolean;
  add?: boolean;
  read?: boolean;
  edit?: boolean;
  delete?: boolean;
  approval?: boolean;
  status?: boolean;
  menu_arrange?: number;
  created_on?: string;
  created_by?: number;
  updated_On?: string;
  updated_by?: number;
  children?: MenuItem[];
}

const BreadcrumbComponent: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [breadCrumbItems, setBreadCrumbItems] = useState<MenuItem[]>([]);

  const pathParts = pathname.split("/").filter(Boolean);

  const handleClick = (index: number) => {
    const to = "/" + pathParts.slice(0, index + 1).join("/");
    navigate(to);
  };

  const menus = useSelector((state: any) => state.Menus);
  const [menuList, setMenuList] = useState<Array<any>>([]);

  useEffect(() => {
    let updateRoutes: MenuItem[] = [];

    const checkIsThere = (url: string, defaultVal: string) => {
      let url_matched = false;

      menuList?.map((m1: MenuItem) => {
        const { children, ...first } = m1;
        if (
          m1.path?.split("/")[1] === url.split("/")[1] &&
          url.split("/").length === 2
        ) {
          updateRoutes.push({
            ...first,
            status: children && children.length > 0 ? false : true,
          });
          url_matched = true;
        }

        if (children) {
          children.map((m2) => {
            const { ...second } = m2;
            if (m2.path === url) {
              updateRoutes.push({
                ...second,
                status: true,
              });
              url_matched = true;
            }
          });
        }
      });
    };

    (pathParts ?? [])?.map((val, index) => {
      const validVal = `/${pathParts.slice(0, index + 1).join("/")}`;
      checkIsThere(validVal, val);
    });

    if (pathParts.find((it) => it === "add")) {
      updateRoutes.push({
        menu: "Add",
        status: true,
      });
    }
    if (pathParts.find((it) => it === "edit")) {
      updateRoutes.push({
        menu: "Edit",
        status: true,
      });
    }
    if (pathParts.find((it) => it === "acounts-onboarding")) {
      updateRoutes.push({
        menu: "Account Onboarding",
        status: true,
      });
    }

    setBreadCrumbItems(updateRoutes);
  }, [menuList, pathname]);

  useEffect(() => {
    if (menus?.data?.result && menus?.data?.result.length > 0) {
      setMenuList(menus.data.result);
    } else {
      setMenuList([]);
    }
  }, [menus]);

  return (
    <div className="breadcrumb_container">
      {breadCrumbItems.map((part, idx) => {
        const isLast = idx === pathParts.length - 1;
        const displayText = part.menu;

        return (
          <React.Fragment key={idx}>
            {isLast ? (
              <h4 className="f4 active">{displayText}</h4>
            ) : (
              <div
                className="breadcrumb_btn"
                onClick={() => (part.status ? handleClick(idx) : {})}
                style={{ cursor: part.status ? "pointer" : "auto" }}
              >
                <h4 className="f4">{displayText}</h4>
                <FontAwesomeIcon icon={["fas", "caret-right"]} />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default BreadcrumbComponent;
